<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card class="grey lighten-4 elevation-0">
        <v-card-title style="background: #e3f2fd; text-transform: capitalize;" class="title">
          Search Logs
          <v-spacer></v-spacer>
          <v-btn class="blue lighten-1" fab small dark @click.native="reloadData()">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn fab small class="grey" @click.native="cancel()">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container fluid grid-list-md >
            <v-layout row wrap>
              <v-flex xs3>
                <v-card>
                  <v-card-title><b>Searches Per Day</b></v-card-title>
                  <v-card-text>
                    <v-data-table hide-actions
                        :headers="headers"
                        :items="searchesPerDay"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.date }}</td>
                        <td class="text-xs-left">{{ props.item.qty }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>

              </v-flex>
              <v-flex xs3>
                <v-card>
                  <v-card-title><b>Documents Opened Per Day</b></v-card-title>
                  <v-card-text>
                    <v-data-table hide-actions
                                  :headers="headers"
                        :items="opensPerDay"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.date }}</td>
                        <td class="text-xs-left">{{ props.item.qty }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>

              </v-flex>
              <v-flex xs3>
                <v-card>
                  <v-card-title><b>Downloads Per Day</b></v-card-title>
                  <v-card-text>
                    <v-data-table hide-actions
                        :headers="headers"
                        :items="downloadsPerDay"
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-left">{{ props.item.date }}</td>
                        <td class="text-xs-left">{{ props.item.qty }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>

              </v-flex>
              <v-flex xs3 text-xs-center>
                <v-card>
                  <v-card-title><b>Export CSV</b></v-card-title>
                  <v-card-text>
                    <v-btn   class="blue" dark @click.native="downloadCSV()">
                      Download CSV
                    </v-btn>
                  </v-card-text>
                </v-card>

              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>


</template>
<script>
import _ from "lodash";
import jsonexport from 'jsonexport';
import FileSaver from 'file-saver';
export default {
  name: 'LoggingExport',
  data () {
    return {
      token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJpYXQiOjE2NDAxMDk0MjEsImV4cCI6MTY0MDE5NTgyMSwiYXVkIjoiaHR0cHM6Ly95b3VyZG9tYWluLmNvbSIsImlzcyI6ImZlYXRoZXJzIiwic3ViIjoiNjY3MSIsImp0aSI6ImEwMzg1ZjEwLWJjY2ItNGQyNS04ZDIzLWQ5N2I1NDQ5NzFmZCJ9.8oO6bQ0-7G61wntZBjaYNHZ_f5h5c4FTfwm-DmqS4Dc',
      downloadsPerDay: [],
      opensPerDay: [],
      loggingData: [],
      searchesPerDay: [],
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Count', value: 'qty' }
      ]
    }
  },
  mounted() {
    this.reloadData()
  },
  computed: {

  },
  methods: {
    downloadCSV(){
      jsonexport(this.loggingData).then((csv)=>{
        var blob = new Blob([csv], {type: "text/plain;charset=utf-8"});
        FileSaver.saveAs(blob, "Search Engine Log Export.csv");
      })
    },
    reloadData() {
      this.$getLogs().then((result)=>{
      this.loggingData = result
        let openList = result.filter((x)=>x.eventType == 'open')
        let searchList = result.filter((x)=>x.eventType == 'query')


        this.opensPerDay = (_(openList).groupBy('date').values().map(
            (group) => ({...group[0], qty: group.length})
        )).value()

        this.searchesPerDay = (_(searchList).groupBy('date').values().map(
            (group) => ({...group[0], qty: group.length})
        )).value()


        console.log('the result', this.opensPerDay)
      })
    },
    cancel () {
      this.$router.back()
    }
  },
}
</script>

